import Styles from '../Styles';
import {View, StyleSheet, Platform, StyleProp, ViewStyle} from 'react-native';
import {Modal, Portal} from 'react-native-paper';
import Localized from 'src/constants/AppStrings';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import DialogueHeader from 'src/components/elements/popupModals/DialogueHeader';
import DialogueBody from 'src/components/elements/popupModals/DialogueBody';
import DialogueButtons, {
  DialogueButtonsProps,
} from 'src/components/elements/popupModals/DialogueButtons';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type ErrorModalProps = {
  isModalVisible: boolean;
  headerTitle: string;
  description: string;
  modalContentStyle?: StyleProp<ViewStyle>;
  onModalClose?: () => void;
} & DialogueButtonsProps;

const {headerFontSize, bodyFontSize} = getLayoutDescriber();

const ErrorModal = (props: ErrorModalProps) => {
  return (
    <Portal>
      <Modal
        visible={props.isModalVisible}
        onDismiss={props.onModalClose}
        style={styles.modalContainer}
      >
        <View style={[styles.modalContainer, styles.modalContentView]}>
          <View style={[styles.modalContent, props.modalContentStyle]}>
            <AVTouchableOpacity
              accessible={true}
              aria-label={Localized.Buttons.cancel}
              accessibilityLabel={Localized.Buttons.cancel}
              accessibilityRole="button"
              role="button"
              onPress={props.onModalClose}
              style={styles.titleContainer}
              hitSlop={Styles.HitSlop_10}
            >
              <CancelIcon />
            </AVTouchableOpacity>
            <DialogueHeader headerTitle={props.headerTitle} />
            <DialogueBody description={props.description} />
            <DialogueButtons {...props} />
          </View>
        </View>
      </Modal>
    </Portal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    flex: 1,
    alignItems: 'center',
    paddingRight: 25,
    justifyContent: 'center',
    paddingLeft: 25,
  },
  modalContentView: {
    ...Platform.select({
      web: {
        marginVertical: -Styles.Spacing.m3,
        marginHorizontal: -Styles.Spacing.m4,
      },
    }),
  },
  acceptSnacktextDesc: {
    top: 15,
  },
  titleContainer: {
    position: 'absolute',
    justifyContent: 'flex-end',
    right: Styles.Heights.h1,
    top: Styles.Heights.h1,
  },
  modalContent: {
    width: 323,
    paddingBottom: 8,
    paddingHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m3,
    backgroundColor: Styles.white,
  },
  innerContent: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Styles.Heights.h3 - 5,
    marginTop: 45,
  },
  descriptionStyle: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m3,
    marginTop: Styles.Spacing.m3,
  },
  headerText: {
    color: Styles.black,
    fontSize: headerFontSize(),
    fontWeight: '700',
    marginLeft: Styles.Spacing.m2,
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
  descText: {
    color: Styles.black,
    fontSize: bodyFontSize(),
    fontWeight: '400',
    textAlign: 'center',
  },
  buttonsContaner: {
    alignItems: 'center',
    justifyContent: 'center',
    marginVertical: Styles.Spacing.m2,
  },
  buttonStyle: {
    marginVertical: Styles.Spacing.m2,
    alignSelf: 'center',
  },
  buttonText: {
    color: Styles.white,
    fontSize: bodyFontSize(),
    fontWeight: '700',
    textAlign: 'center',
    width: 250,
  },
});
export default ErrorModal;
